"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const constants_1 = require("@/common/constants");
exports.default = (0, vue_1.defineComponent)({
    name: 'LanguageSelectionDialog',
    props: {
        preferencesManager: {
            type: Object,
            required: true,
        },
    },
    methods: {
        switchLanguageTo(langId) {
            this.preferencesManager.set('lang', langId);
            window.location.reload();
        },
    },
    computed: {
        ALL_LANGUAGES() {
            return constants_1.ALL_LANGUAGES;
        },
        LANGUAGES() {
            return constants_1.LANGUAGES;
        },
    },
});
